/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Test_ConnectionInputs */

const en_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test Connection`)
};

const fr_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de connexion`)
};

const de_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testverbindung`)
};

const it_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione di prova`)
};

const ru_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверить соединение`)
};

const es_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probar conexión`)
};

const zh_cn2_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测试连接`)
};

const ja_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続テスト`)
};

const hi_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कनेक्शन का परीक्षण करें`)
};

const pt_pt2_live_caption_test_connection = /** @type {(inputs: Live_Caption_Test_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conexão de teste`)
};

/**
* | output |
* | --- |
* | "Test Connection" |
*
* @param {Live_Caption_Test_ConnectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_test_connection = /** @type {((inputs?: Live_Caption_Test_ConnectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Test_ConnectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_test_connection(inputs)
	if (locale === "de") return de_live_caption_test_connection(inputs)
	if (locale === "it") return it_live_caption_test_connection(inputs)
	if (locale === "ru") return ru_live_caption_test_connection(inputs)
	if (locale === "es") return es_live_caption_test_connection(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_test_connection(inputs)
	if (locale === "ja") return ja_live_caption_test_connection(inputs)
	if (locale === "hi") return hi_live_caption_test_connection(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_test_connection(inputs)
	return en_live_caption_test_connection(inputs)
});